/** @format */

import moment from "moment";
import React from "react";
import { Collegamento } from "./Collegamento";
import {
  TGiornoPresenze,
  TTurnoPresenze,
} from "../../../../redux-modules/declarations/maps/presenzeVista";
import { diUnAltroGiorno, orario, tinta, titoloTurno } from "../../ViewPresenze/format";

/** Nella cella del giorno solo l'orario; riposo e recupero con il loro nome. */
const etichetta = (t: TTurnoPresenze): string =>
  t.lavorativo ? orario(t.ora_inizio, t.ora_fine) : titoloTurno(t);

interface Props {
  giorni: TGiornoPresenze[];
  oggi: string;
  /** collegamento ai turni, se l'utente può aprirli */
  turni: string | null;
}

/**
 * La settimana di chi è collegato, da lunedì a domenica: turni con lo stato della vista Presenze,
 * giustificativi e festività. Si mostra al posto di "Chi c'è" a chi non lo vede.
 */
export const Settimana = ({ giorni, oggi, turni }: Props): JSX.Element => (
  <section className="scheda" aria-labelledby="titolo-settimana">
    <div className="testa">
      <h2 id="titolo-settimana">La mia settimana</h2>
      {turni && (
        <Collegamento className="collegamento" to={turni}>
          I miei turni
        </Collegamento>
      )}
    </div>
    <ol className="settimana">
      {giorni.map(g => {
        const delGiorno = g.turni.filter(t => !t.giorno_prima && t.visibile);
        // come i turni: il permesso del notturno del giorno prima resta in quel giorno
        const giustificativi = g.giustificativi.filter(gi => !diUnAltroGiorno(gi));
        const classi = [g.data === oggi ? "oggi-giorno" : "", g.festivita ? "festa" : ""]
          .join(" ")
          .trim();
        return (
          <li
            key={g.data}
            className={classi || undefined}
            aria-current={g.data === oggi ? "date" : undefined}
          >
            <span className="g">
              {moment(g.data).format("ddd")} <b>{moment(g.data).format("D")}</b>
            </span>
            {g.festivita && (
              <span className="tc non_lavorativo" title={g.festivita}>
                {g.festivita}
              </span>
            )}
            {delGiorno.map(t => (
              <span
                key={t.id}
                className={`tc numeri ${t.stato}`}
                title={`${titoloTurno(t)}${t.sede ? `, ${t.sede}` : ""}`}
              >
                {etichetta(t)}
              </span>
            ))}
            {giustificativi.map(gi => (
              <span
                key={gi.richiesta_id}
                className={`tc giust${gi.stato === "in_attesa" ? " in-attesa" : ""}`}
                style={{
                  background: tinta(gi.colore, 0.18),
                  borderColor: tinta(gi.colore, 0.7),
                  color: "#1E2333",
                }}
                title={`${gi.nome}${gi.dalle ? ` ${gi.dalle}–${gi.alle}` : ""}${
                  gi.stato === "in_attesa" ? ", in attesa" : ""
                }`}
              >
                {gi.nome}
                {gi.dalle ? ` ${gi.dalle}–${gi.alle}` : ""}
                {gi.stato === "in_attesa" ? " · in attesa" : ""}
              </span>
            ))}
            {!delGiorno.length && !giustificativi.length && !g.festivita && (
              <span className="vuoto">Nessun turno</span>
            )}
          </li>
        );
      })}
    </ol>
  </section>
);
